export enum ExceptionCode {
  Default = 'default_err',
  Auth = 'auth_err',
  Unauthorized = 'unauthorized_err',
  InternalServerError = 'internal_server_err',
  Forbidden = 'forbidden_err',
  UnprocessableEntity = 'unprocessable_entity',
  NotFound = 'not_found_err'
}
